import React from "react";
import SliderModule, { Settings } from "react-slick";

export const Slider: React.FunctionComponent<Settings & {ref: any}> & SliderModule =
  (SliderModule as any).default || SliderModule;

export * from 'react-slick';
